import isArray from "lodash/isArray";
import get from "lodash/get";
import uniq from "lodash/uniq";
import * as Quiz from "lib/models/Quiz";

// Get a flat Array of quiz specifications from all quizzes that have been answered
const getQuizSpecifications = async state => {
  const quizzes = uniq(state.answers.map(a => a.quiz));

  let specifications = [];

  for (const id of quizzes) {
    const quiz = await Quiz.getById(id);
    specifications = [...specifications, ...quiz.specifications];
  }

  return specifications;
};

/**
 * Filter products based upon quiz specifications
 * Products need all specifications to be included
 */
const filterByQuizSpecifications = async (products, state) => {
  const specifications = await getQuizSpecifications(state);

  if (!specifications.length) return products;

  // Filter products that contain all quiz specifications
  return products.filter(product => {
    const matches = specifications.filter(({ title, specification }) => {
      let value = get(product.specs, title, null);

      if (!value) return false;

      value = isArray(value) ? value : [value];

      return value.includes(specification);
    });

    return matches.length === specifications.length;
  });
};

export default filterByQuizSpecifications;
